// Potvrdenie úspešných AJAX akcií — slovenské dvojče locale/cs/ajaxFeedback.js.
export default {
  coupon: 'Zľavový kupón bol uplatnený.',
  watchdog: 'Stráženie je nastavené. Dáme vám vedieť e-mailom.',
};
